var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex flex-column flex-row-fluid wrapper mr-lg-10 mr-sm-0"},[_c('div',{staticClass:"content d-flex flex-column flex-column-fluid p-0"},[_c('div',{staticClass:"d-flex flex-column-fluid"},[_c('div',{staticClass:"container-fluid mt-4"},[_c('router-view')],1)])]),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }